import { render, staticRenderFns } from "./SharedProduct.vue?vue&type=template&id=60f5cb20&"
import script from "./SharedProduct.vue?vue&type=script&lang=js&"
export * from "./SharedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SharedProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SharedProduct.vue"
export default component.exports